var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1668 36.5004C15.5266 36.5004 18.2502 33.7768 18.2502 30.4171C18.2502 27.0573 15.5266 24.3337 12.1668 24.3337C8.8071 24.3337 6.0835 27.0573 6.0835 30.4171C6.0835 33.7768 8.8071 36.5004 12.1668 36.5004Z",
    fill: "#C1C3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2879 40.7579C17.2158 43.0696 15.2083 46.7804 15.2083 50.9475V51.7079H2.28125C1.03417 51.7079 0 50.6737 0 49.4267V47.9058C0 43.2825 3.74125 39.5413 8.36458 39.5413H15.9687C17.5504 39.5413 19.0408 39.9975 20.2879 40.7579Z",
    fill: "#C1C3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8333 36.5004C64.1931 36.5004 66.9167 33.7768 66.9167 30.4171C66.9167 27.0573 64.1931 24.3337 60.8333 24.3337C57.4736 24.3337 54.75 27.0573 54.75 30.4171C54.75 33.7768 57.4736 36.5004 60.8333 36.5004Z",
    fill: "#C1C3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9998 47.9058V49.4267C72.9998 50.6737 71.9657 51.7079 70.7186 51.7079H57.7915V50.9475C57.7915 46.7804 55.784 43.0696 52.7119 40.7579C53.959 39.9975 55.4494 39.5413 57.0311 39.5413H64.6352C69.2586 39.5413 72.9998 43.2825 72.9998 47.9058Z",
    fill: "#C1C3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5 38.0212C41.5396 38.0212 45.625 33.9358 45.625 28.8962C45.625 23.8566 41.5396 19.7712 36.5 19.7712C31.4604 19.7712 27.375 23.8566 27.375 28.8962C27.375 33.9358 31.4604 38.0212 36.5 38.0212Z",
    fill: "#C1C3C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8647 42.5837H28.1356C23.5214 42.5837 19.771 46.3341 19.771 50.9483V55.5108C19.771 56.7701 20.793 57.7921 22.0522 57.7921H50.9481C52.2073 57.7921 53.2293 56.7701 53.2293 55.5108V50.9483C53.2293 46.3341 49.4789 42.5837 44.8647 42.5837Z",
    fill: "#C1C3C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.e0da2b681a367f5a3bb79f62d5c2176f.svg";
export { ForwardRef as ReactComponent };